<template>
    <div class="login-box">
        <section class="login-form__container">
            <div class="login-aside">
                <img src="../assets/img/login-side_bg.png" alt="">
            </div>
            <el-form :model="loginUser" :rules="rules" ref="loginForm" class="loginForm">
                <div class="login-form__title">
                    <span class="login_welcome">金穗智管</span>
                </div>
                <el-form-item prop="name">
                    <v-svg-icon name="icon-zhanghu" class="login-form__icon"/>
                    <el-input class="login-form__input" v-model="loginUser.name"
                              @keyup.enter.native="submitForm('loginForm')" placeholder="请输入账号/商户号"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <!--<i class="iconfont icon-mima login-form__icon"></i>-->
                    <v-svg-icon name="icon-mima" class="login-form__icon"/>
                    <el-input class="login-form__input" v-model="loginUser.password"
                              @keyup.enter.native="submitForm('loginForm')" placeholder="请输入密码"
                              type="password"></el-input>
                </el-form-item>

<!--                    <router-link to="/Account">忘记密码？</router-link>-->
                    <div class="login-tip clear right">
                        <el-link href="/account/home">
                            忘记密码?
                        </el-link>
                    </div>

                <el-button type="primary" @click="submitForm('loginForm')" class="login-form_btn">登 录</el-button>
            </el-form>
        </section>
        <p style="text-align: center;color: #fff;position: absolute;left:0;right: 0; bottom: 0;">&copy;&nbsp;2019&nbsp;北京奇点在线科技有限公司&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;<a
            style="color: #fff;text-decoration: underline;" href="http://www.beian.miit.gov.cn">京ICP备18055826号</a></p>
    </div>
</template>

<script>
import qs from 'qs'
import router from '@/router'

export default {
    name: 'login',
    data () {
        return {
            loginUser: {
                name: '',
                password: ''
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: '请输入用户名/商户号',
                        trigger: 'change'
                    }
                ],
                password: [
                    { required: true, message: '密码不能为空', trigger: 'blur' },
                    { min: 6, max: 30, message: '长度在 6 到 30 个字符', trigger: 'blur' }
                ]
            }
        }
    },
    beforeRouteEnter (to, from, next) {
        if (localStorage.getItem('token')) {
            router.replace('/index/home')
        } else {
            next()
        }
    },
    methods: {
        submitForm (formName) {
            localStorage.clear()
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.$http.post('/api/user/login', qs.stringify({
                        username: this.loginUser.name,
                        password: this.loginUser.password
                    }))
                        .then(res => {
                            if (res.code === 0) {
                                this.$message.success({
                                    message: '登录成功'
                                })
                                localStorage.setItem('token', res.data.token)
                                localStorage.setItem('USERINFO', JSON.stringify(res.data))
                                localStorage.setItem('Subject', res.data.is_popup)
                                if (res.data.is_popup === 0) {
                                    localStorage.setItem('SubjectID', res.data.subject.id)
                                }
                                router.push('/index')
                            } else {
                                this.$message.error(res.message)
                            }
                        })
                        .catch(err => {
                            console.log('\'/login\'', err)
                            this.$message.error('网络错误，请稍候再试。')
                        })
                } else {
                    return false
                }
            })
        },
        isEmpty (value) {
            return (
                value === undefined ||
                value === null ||
                (typeof value === 'object' && Object.keys(value).length === 0) ||
                (typeof value === 'string' && value.trim().length === 0)
            )
        }
    }
}
</script>

<style scoped lang="scss">
    @import '../assets/style/login.scss';
</style>
<style lang="scss">
    .login-form__container {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.5);

        ::-webkit-input-placeholder {
            color: rgba(77, 77, 77, 0.5);
            font-weight: 600;
        }

        ::-moz-placeholder {
            color: rgba(77, 77, 77, 0.5);
            font-weight: 600;
        }

        :-ms-input-placeholder {
            color: rgba(77, 77, 77, 0.5);
            font-weight: 600;
        }

        :-moz-placeholder {
            color: rgba(77, 77, 77, 0.5);
            font-weight: 600;
        }

        display: flex;
        align-items: center;

        .login-aside {
            width: 50%;

            img {
                width: 395px;
                height: 304px;
            }
        }

        .loginForm {
            width: 50%;
            padding-right: 71px;
            padding-left: 70px;
        }
    }

    .login-form__input input.el-input__inner {
        padding-left: 45px;
        border: 0;
        border-radius: 0;
        border-bottom: 1px solid #ccc;
        height: 48px;
        line-height: 48px;
        font-size: 18px;
        margin-top: 40px;
    }

    .login-tip {
        margin-top: 22px;

        a {
            text-align: right;
            color: #4d4d4d;
            opacity: 0.5;
            font-size: 15px;
        }
    }

    @media screen and (max-width: 1281px) {
        .login-form__container {
            transform: scale(0.88);
        }
    }
</style>
